module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/golfing_b5353a.jpg";